import { render, staticRenderFns } from "./otherManagement.vue?vue&type=template&id=3e8e7ac9&scoped=true&"
import script from "./otherManagement.vue?vue&type=script&lang=js&"
export * from "./otherManagement.vue?vue&type=script&lang=js&"
import style0 from "./otherManagement.vue?vue&type=style&index=0&id=3e8e7ac9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8e7ac9",
  null
  
)

export default component.exports